import * as _ from 'underscore';
import { TagsHelper } from '../../helpers/TagsInputHelper';
import { ITagsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class RemoveTagsFromPublishedConnectionsRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    // The server returns quoted tags unquoted.  This re-adds the double quotes if needed
    const tagsList = _.map(tags, (tag: string) => TagsHelper.quote(tag));

    super('removeTagsFromPublishedConnections', {
      ids: ids,
      tags: tagsList
    });
  }
}
